function updateInstallmentPrices() {
    // Get the main product price
    let mainPriceElement = document.getElementById("main-price");
    let afterpayPriceElement = document.getElementById("afterpay-price");
    let zipPriceElement = document.getElementById("zip-price");
    if (!mainPriceElement || !afterpayPriceElement || !zipPriceElement) return;
    let mainPrice = parseFloat(mainPriceElement.textContent.replace('$', ''));
    if (Number.isNaN(mainPrice)) return;
    // Calculate installment price (divide by 4)
    let installmentPrice = (mainPrice / 4).toFixed(2);
    // Update Afterpay and Zip Pay installment prices
    afterpayPriceElement.textContent = `$${installmentPrice} x 4 Payments`;
    zipPriceElement.textContent = `$${installmentPrice} x 4 Payments`;
}
// Run on page load
document.addEventListener("DOMContentLoaded", updateInstallmentPrices);
// Optionally, observe for price changes if the price updates dynamically
const mainPriceElement = document.getElementById("main-price");
if (mainPriceElement) {
  const priceObserver = new MutationObserver(updateInstallmentPrices);
  priceObserver.observe(mainPriceElement, { childList: true, subtree: true, characterData: true });
}

// Add the cart drawer fix code below this line

// Wait for DOM to be fully loaded before adding event listeners
document.addEventListener('DOMContentLoaded', function() {
  // Add event listeners to all recommendation buttons
  if (typeof setupRecommendedProductButtons === 'function') {
    setupRecommendedProductButtons();
  }
  
  // Listen for drawer open events to refresh recommendations
  document.addEventListener('drawerOpen', function(event) {
    if (event.detail && event.detail.id === 'CartDrawer') {
      // Complete refresh of the entire drawer content when opened
      setTimeout(function() {
        if (typeof forceCartDrawerRefresh === 'function') forceCartDrawerRefresh();
      }, 200);
    }
  });
  
  // Setup event listeners for cart refresh events
  document.addEventListener('cart:refresh', function() {
    setTimeout(function() {
      if (typeof forceCartDrawerRefresh === 'function') forceCartDrawerRefresh();
    }, 300);
  });
  
  // Fix for remove button redirecting to product page
  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('cart__remove') || event.target.closest('.cart__remove')) {
      event.preventDefault();
      event.stopPropagation();
      
      const item = event.target.closest('[data-variant-id]');
      if (!item) return;
      
      const variantId = item.dataset.variantId;
      if (!variantId) return;
      
      // Show loading state
      document.body.classList.add('cart-updating');
      
      // Remove the item from cart
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {
            [variantId]: 0
          }
        })
      })
      .then(response => response.json())
      .then(cart => {
        // Force complete refresh of the cart drawer
        if (typeof forceCartDrawerRefresh === 'function') forceCartDrawerRefresh();
        
        // Trigger cart refresh event
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart }
        }));
      })
      .catch(error => {
        console.error('Error removing item from cart:', error);
        document.body.classList.remove('cart-updating');
      });
    }
  });
});